<template>
  <div>
    <home-hero />
    <home-popular />
    <home-who />
    <home-categories />
    <home-explore />
    <home-contact />
  </div>
</template>

<script setup>
import HomeHero from "@/components/home/home-hero.vue";
import HomePopular from "@/components/home/home-popular.vue";
import HomeWho from "@/components/home/home-who.vue";
import HomeCategories from "@/components/home/home-categories.vue";
import HomeExplore from "@/components/home/home-explore.vue";
import HomeContact from "@/components/home/home-contact.vue";
import {ElNotification} from "element-plus";
import {Auth} from "@/core/api/auth.js";
import {useRoute} from "vue-router";
import {computed, onMounted} from "vue";

const route = useRoute()

const token = computed(() =>
  route.query.token ? (route.query.token) : undefined,
);
const uid = computed(() =>
  route.query.uid ? (route.query.uid) : undefined,
);
const payment = computed(() =>
  route.query.payment ? (route.query.payment) : undefined,
);

const activateAccount = async () => {
  if (token.value && uid.value && route.name === "activate-user") {
    const res = await Auth.activateUser(token.value, uid.value)

    if (res.data.activateUser) {
      ElNotification({
        message: t("popup.activationSuccess"),
        type: "success"
      });
    } else {
      ElNotification({
        title: t("popup.error"),
        message: res.errors[0].message,
        type: "error"
      });
    }
  }
};

onMounted(async () => {
  await activateAccount();

  switch (payment.value) {
    case "processing":
      ElNotification({
        message: t("popup.paymentProcessing"),
        type: "success"
      });

      break

    case "success":
      ElNotification({
        message: t("popup.paymentSuccess"),
        type: "success"
      });

      break

    case "cancel":
      ElNotification({
        message: t("popup.paymentCancel"),
        type: "error"
      });

      break

    default:
      console.log('')
  }
});
</script>

<style lang="scss" scoped>

</style>